import type { InjectionKey } from 'vue'

import { type defaultFormatter } from '../formatters'

export const appConfigProviderKey = Symbol() as InjectionKey<{ mediaBaseUrl: string }>
export const formatterProviderKey = Symbol() as InjectionKey<{
  formatNumber: (typeof defaultFormatter)['formatNumber']
  formatDateOnly: (typeof defaultFormatter)['formatDateOnly']
  formatDateOnlyLong: (typeof defaultFormatter)['formatDateOnlyLong']
  formatDateTime: (typeof defaultFormatter)['formatDateTime']
  formatDateTimeLong: (typeof defaultFormatter)['formatDateTimeLong']
  formatDateTimeRelative: (typeof defaultFormatter)['formatDateTimeRelative']
  formatTimeOnly: (typeof defaultFormatter)['formatTimeOnly']
  formatMoney: (typeof defaultFormatter)['formatMoney']
  getCurrencyLabel: (typeof defaultFormatter)['getCurrencyLabel']
}>

export const linksProviderKey = Symbol() as InjectionKey<{
  getCreatorLink: (creatorId: string | number) => string
  getAdvertiserLink: (advertiserId: string | number) => string
  getCampaignLink: (campaignId: string | number) => string
}>
